import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { src: String, type: { type: String, default: "image" } }

  open(event) {
    event.preventDefault()
    const source = this.hasSrcValue
      ? this.srcValue
      : event.currentTarget.querySelector("img")?.currentSrc || event.currentTarget.querySelector("img")?.src
    if (!source) return

    this.close({ restoreFocus: false })
    this.opener = event.currentTarget

    this.dialog = document.createElement("dialog")
    this.dialog.className = "m-auto max-h-screen max-w-full border-0 bg-transparent p-4 backdrop:bg-black/80"
    this.dialog.setAttribute("aria-label", this.opener.getAttribute("aria-label") || "Aperçu du document")
    this.dialog.addEventListener("click", (e) => { if (e.target === this.dialog) this.dialog.close() })
    this.dialog.addEventListener("close", () => this.close())

    let media
    if (this.typeValue === "pdf") {
      media = document.createElement("iframe")
      media.src = this.srcValue
      media.className = "w-[90vw] h-[90vh] rounded-lg shadow-2xl bg-white"
    } else {
      media = document.createElement("img")
      media.src = source
      media.className = "max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
    }

    const closeButton = document.createElement("button")
    closeButton.type = "button"
    closeButton.autofocus = true
    closeButton.setAttribute("aria-label", "Fermer")
    closeButton.className = "absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 text-black text-2xl leading-none shadow-lg cursor-pointer hover:bg-white"
    closeButton.textContent = "×"
    closeButton.addEventListener("click", () => this.dialog.close())

    this.dialog.appendChild(media)
    this.dialog.appendChild(closeButton)
    document.body.appendChild(this.dialog)
    this.dialog.showModal()
  }

  close({ restoreFocus = true } = {}) {
    if (this.dialog?.open) this.dialog.close()
    this.dialog?.remove()
    this.dialog = null
    if (restoreFocus && this.opener?.isConnected) this.opener.focus()
    this.opener = null
  }

  disconnect() {
    this.close()
  }
}
